import React from 'react'
import { Button, Modal, Text } from '@wework/dieter-ui'

export default function ReloadDialog({ open, onClose }: any) {
  return (
    <Modal style={{ height: 'auto', width: 560 }} onClose={onClose} open={open}>
      <Modal.Header style={{ margin: 0 }}>Refresh Page</Modal.Header>
      <Modal.Content>
        <Text>
          Occupancy status change or building index refresh failed. Please click
          below to refresh this page. Check for changes after refresh.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
